"use strict";
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NOOP_HTTP_TEXT_PROPAGATOR = exports.NoopHttpTextPropagator = void 0;
/**
 * No-op implementations of {@link HttpTextPropagator}.
 */
var NoopHttpTextPropagator = /** @class */ (function () {
    function NoopHttpTextPropagator() {
    }
    /** Noop inject function does nothing */
    NoopHttpTextPropagator.prototype.inject = function (context, carrier, setter) { };
    /** Noop extract function does nothing and returns the input context */
    NoopHttpTextPropagator.prototype.extract = function (context, carrier, getter) {
        return context;
    };
    return NoopHttpTextPropagator;
}());
exports.NoopHttpTextPropagator = NoopHttpTextPropagator;
exports.NOOP_HTTP_TEXT_PROPAGATOR = new NoopHttpTextPropagator();
//# sourceMappingURL=NoopHttpTextPropagator.js.map